
import {
    defineComponent, nextTick, PropType, Ref, ref, watch
} from 'vue';
import noticeBase from '@/util/notice.base';
import enlargeImage from '@/components/common/enlarge-image/index.vue';

type BeforeChoose = (next: () => void) => void | false;

export default defineComponent({
    emits: ['change', 'remove'],
    components: {
        enlargeImage
    },
    props: {
        isShowEditImage: {
            type: Boolean,
            default: false
        },
        beforeChoose: {
            type: Function as PropType<BeforeChoose>,
            default: null
        }
    },
    setup(props, { emit }) {
        const fileInput: Ref<any> = ref();
        const chooseImg: Ref<any> = ref();
        const deleteBtn: Ref<any> = ref();
        const isFile = ref(false);

        const isShowLarge = ref(false);
        const fileUrl = ref('');

        const openFile = () => {
            fileInput.value.click();
        };

        const choose = () => {
            if (props.beforeChoose) {
                props.beforeChoose(openFile);
                return;
            }
            openFile();
        };

        const change = () => {
            const file = fileInput.value.files[0];
            if (!/\.(?:jpg|png|bmp)$/.test(file.name)) {
                noticeBase.messageBox('alert', WordList.ImportFaceExtError, WordList.Notice, 'info')(() => false);
                return;
            }
            isFile.value = true;
            emit('change', fileInput.value.files[0]);
            chooseImg.value.src = window.URL.createObjectURL(fileInput.value.files[0]);
            fileUrl.value = window.URL.createObjectURL(fileInput.value.files[0]);
            chooseImg.value.onload = () => {
                if (chooseImg.value.clientWidth > chooseImg.value.clientHeight) {
                    chooseImg.value.style.width = '100%';
                    chooseImg.value.style.height = 'auto';
                } else {
                    chooseImg.value.style.width = 'auto';
                    chooseImg.value.style.height = '100%';
                }
                deleteBtn.value.style.right = `${246 - chooseImg.value.clientWidth}px`;
                deleteBtn.value.style.top = `${chooseImg.value.clientHeight - deleteBtn.value.clientHeight}px`;
            };
        };

        const remove = () => {
            emit('remove');
            isFile.value = false;
            fileInput.value.value = '';
            fileUrl.value = '';
        };

        // 如果编辑编辑的时候有导入过人脸，那么显示UI设计的图片
        watch(() => props.isShowEditImage, () => {
            if (props.isShowEditImage) {
                nextTick(() => {
                    isFile.value = true;
                    // TOOD 图片UI为设计
                    chooseImg.value.src = require('@/assets/image/face-edit.png');
                    fileUrl.value = chooseImg.value.src;

                    chooseImg.value.onload = () => {
                        if (chooseImg.value.clientWidth > chooseImg.value.clientHeight) {
                            chooseImg.value.style.width = '100%';
                            chooseImg.value.style.height = 'auto';
                        } else {
                            chooseImg.value.style.width = 'auto';
                            chooseImg.value.style.height = '100%';
                        }
                        deleteBtn.value.style.right = `${246 - chooseImg.value.clientWidth}px`;
                        deleteBtn.value.style.top = `${chooseImg.value.clientHeight - deleteBtn.value.clientHeight}px`;
                    };
                });
            }
        });

        return {
            fileInput,
            chooseImg,
            isFile,
            deleteBtn,
            choose,
            change,
            remove,
            isShowLarge,
            fileUrl
        };
    }
});
